<template>
  <div class="top-view">
    <div class="graph-view-text">
      <div class="graph-view_title">
        <div class="top-img"></div>
        <span>{{ $t(title) }}</span>
      </div>
    </div>
    <div v-if="searchTabActive !== 'CurvedSurface'" class="graph-view_describe ">
      <div class="graph-view_availablerange"><span class="graph-view_block"></span><span class="graph-view_text">{{ $t(strColor1) }}</span></div>
      <div class="graph-view_screen"><span class="graph-view_block"></span><span class="graph-view_text">{{ $t(strColor2) }} </span></div>
    </div>
    <div class='graph-view_checkbox'>
      <div class='Projector_checkbox'>
        <el-checkbox v-model='projectorCheckedTopData'><span>{{$t('T_CHANGE_PJ_POS')}}</span></el-checkbox>
      </div>
    </div>
    <Cv
      id="topView"
      :w="widthInit"
      :h="heightInit"
      :pjRect="pjImgRect"
      :roomRect="roomRect"
      :arrDashLines="arrDashLines"
      :arrDashRemainLines="arrDashRemainLines"
      :arrLightingArea="arrLightingArea"
      :arrOffsetLines="arrOffsetLines"
      :arrRectLines="arrRectLines"
      :avlRect="avlRect"
      :arrHelpLines="arrHelpLines"
      :arrHelpText="arrHelpText"
      :arrCatchArea="arrCatchArea"
      :arrCurveRect="arrCurveRect"
      :arrRectArea="arrRectArea"
      @setArrHelpLine="setArrHelpLine"
      @moveCenter="moveCenter"
      ref="topView"
    >
    </Cv>
    <div class="graph-slider-block" :class="{'hidden':this.hAngleFlag === false}">
      <div class="slider-title-v" :title="$t(sliderTitle)">{{ $t(sliderTitle) }}</div>
      <div class="slider-item" :title="$t(sliderMsg1)">{{ $t(sliderMsg1) }}</div>
      <el-slider
        v-model="hAngleData"
        :max="sliderMax"
        :min="sliderMin"
        vertical
        :height="sliderHeight"
        :disabled="!hAngleFlagData"
        :step="0.1"
        :show-tooltip= false>
      </el-slider>
      <div class="slider-item" :title="$t(sliderMsg2)">{{ $t(sliderMsg2) }}</div>
      <div class="graph-view_slider-input">
        <el-input v-model.number="hAngleDataSlider" class="side_input" :class="{'red_out': (!indAngleSwitch && isHAngleOut) || (indAngleSwitch && !isOnCornerAreas)}" :disabled="!hAngleFlagData" @input="testDigitalNegative($event, 'hAngleData')" @blur="testDigitalNegativeBlur">
          <template slot="suffix"><span style="line-height: 26px;">{{ sliderAppend }}</span></template>
        </el-input>
      </div>
    </div>
    <div type="primary" :class="{ 'middle-btn':this.throw_distance_checked === false,'middle-btndis':this.throw_distance_checked === true }" :style="{ right: centerPosition.x + 'px', top: centerPosition.y + 'px'}" size="small" @click="toCenter()">{{ $t('T_CENTER') }}</div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'topView',
  data () {
    return {
      title: 'T_TOP_VIEW',
      strColor1: 'T_AVAILABLE_RANGE',
      strColor2: 'T_MSG_OUT_WALL',
      sliderTitle: 'T_ROTATION',
      sliderMsg1: 'T_RIGHT',
      sliderMsg2: 'T_LEFT',
      sliderMax: 90,
      sliderMin: -90,
      sliderAppend: '°',
      child: null,

      pjImgRect: {},
      roomRect: {},
      avlRect: {},
      arrDashLines: [],
      arrDashRemainLines: [],
      arrLightingArea: [],
      arrOffsetLines: [],
      arrRectLines: [],
      arrCatchArea: [],
      arrCurveRect: [],
      arrRectArea: [],
      arrHelpLines: [],
      arrHelpText: [],
      widthInit: 0,
      heightInit: 0,

      helpDisMin: 20,
      helpDisMax: 40,
      helpTextDis: 37,
      helpBesideDis: 45,
      sliderHeight: '0px',
      hAngleDataSlider: 0,
      mp: {},
      offsetX: 0,
      centerPosition: {
        x: 0,
        y: 0
      },
      isLShaped01: this.$commonViewJs.isLShaped01()
    }
  },
  computed: {
    ...mapState([
      'pjY',
      'pjZ',
      'graph',
      'hAngle',
      'houseInfo',
      'hAngleFlag',
      'hAngleFlag',
      'drawData',
      'lenghProInit',
      'curveCenter',
      'curveRadius',
      'curveCentralAngle',
      'curveShape',
      'curveChordLength',
      'curveScreenHeight',
      'widthProInit',
      'projectorCheckedTop',
      'offset',
      'curveDirection',
      'curveDepth',
      'dashFlag',
      'dashData',
      'isOnCornerAreas',
      'indAngleSwitch',
      'limitData',
      'keyStoneHorizontal',
      'searchTabActive',
      'throwDistanceChecked',
      'projectionCoverScreen',
      'position'
    ]),
    ...mapGetters([
      'unitLabel'
    ]),
    coverScreenColor: {
      get () {
        return this.projectionCoverScreen ? this.$constant.greenColor : this.$constant.redColor
      }
    },
    hAngleFlagData () {
      return this.hAngleFlag
    },
    hAngleData: {
      get () {
        return this.hAngle
      },
      set (value) {
        this.$store.commit('SET_HANGLE', value)
      }
    },
    projectorCheckedTopData: {
      get () {
        return this.projectorCheckedTop
      },
      set (value) {
        this.$store.commit('SET_PROJECTORCHECKEDTOP', value)
      }
    },
    isHAngleOut () {
      return !this.keyStoneHorizontal
    },
    throw_distance_checked: {
      get () {
        return this.throwDistanceChecked
      }
    }
  },
  created () {
    this.isLShaped01 = this.$commonViewJs.isLShaped01()
    this.widthInit = this.isLShaped01 ? this.houseInfo.roomW : this.houseInfo.roomD - this.offsetX
    this.heightInit = this.isLShaped01 ? this.houseInfo.roomH : this.houseInfo.roomW
  },
  mounted () {
    this.child = this.$refs.topView
    this.sliderHeight = this.child.$refs.canvas_side.offsetHeight * 0.35 + 'px' // TODO
    this.hAngleDataSlider = this.hAngleData
    this.initCanvasData()
    this.$nextTick(function () {
      // this.child.drawCv()
    })
    this.unWatchDrawData = this.$watch('drawData', function () {
      this.initCanvasData()
      this.$nextTick(function () {
        this.child.onGraphChanged()
      })
    }, {deep: true})

    this.unWatchHouseInfo = this.$watch('houseInfo', function () {
      this.initCanvasData()
      this.widthInit = this.isLShaped01 ? this.houseInfo.roomW : this.houseInfo.roomD - this.offsetX
      this.heightInit = this.isLShaped01 ? this.houseInfo.roomH : this.houseInfo.roomW
      this.$nextTick(function () {
        this.child.onHouseInfoChanged()
      })
    }, {deep: true})
  },
  destroyed () {
    this.unWatchDrawData()
    this.unWatchHouseInfo()
  },
  methods: {
    ...mapMutations([
      'SET_HANGLE',
      'PJX'
    ]),

    initCanvasData () {
      // 凸面时，如果 投影区域 大于 屏幕区域，整体向右移动this.offsetX
      this.offsetX = this.$commonViewJs.getOffsetOfX()
      this.isLShaped01 = this.$commonViewJs.isLShaped01()
      this.widthInit = this.isLShaped01 ? this.houseInfo.roomW : this.houseInfo.roomD - this.offsetX
      this.heightInit = this.isLShaped01 ? this.houseInfo.roomH : this.houseInfo.roomW
      if (!this.drawData) {
        return
      }
      // 房间矩形边框
      this.roomRect = null
      // 连线
      this.arrRectLines = []
      // 虚线
      this.arrDashLines = []
      this.arrLightingArea = []
      // 虚线
      this.arrDashRemainLines = []
      // Offset
      this.arrOffsetLines = []
      // 投影仪可拖动区域
      this.avlRect = null
      // 辅助线
      this.arrHelpLines = []
      // 辅助线上尺寸大小
      this.arrHelpText = []
      // 斜边投影区域
      this.arrCatchArea = []
      // 曲面弧
      this.arrCurveRect = []
      // 四边形
      this.arrRectArea = []

      this.setPjRect()
      this.setArrDashLines()
      this.setArrDashRemainLines()
      this.setRoomRect()
      this.setAvlRect()
      this.setArrCatchArea()
      this.setArrRectLines()
      this.setArrLightingArea()
      this.setArrCurveRect()
      // this.setArrHelpLine()
      // this.setArrHelpText()
    },
    setPjRect () {
      var x = this.isLShaped01 ? this.$commonViewJs.getAx() : this.$commonViewJs.getAy() - this.offsetX
      var y = this.isLShaped01 ? this.$commonViewJs.getAz() : this.houseInfo.roomW - this.$commonViewJs.getAx()
      var width = this.lenghProInit
      var height = this.widthProInit

      this.pjImgRect = this.$draw.toRect(x, y, width, height)
    },
    setRoomRect () {
      this.roomRect = this.$draw.toRect(
        0,
        0,
        this.widthInit,
        this.heightInit
      )
    },
    setAvlRect () {
      if (this.$commonViewJs.isAvlExist()) {
        var k, l
        this.avlRect = {}
        if (this.isLShaped01) {
          k = this.$draw.toPoint(
            this.$commonViewJs.getQx(),
            this.position === 1 ? this.$commonViewJs.getLSTH() : this.$commonViewJs.getLSWH()
          )
          l = this.$draw.toPoint(
            this.$commonViewJs.getPx(),
            this.position === 1 ? this.$commonViewJs.getLSWH() : this.$commonViewJs.getLSTH()
          )
          // console.log('k', k, 'l', l, l.x - k.x, l.y - k.y)
        } else {
          k = this.$draw.toPoint(
            this.$commonViewJs.getPy(),
            this.houseInfo.roomW - this.$commonViewJs.getPx()
          )
          l = this.$draw.toPoint(
            this.$commonViewJs.getQy(),
            this.houseInfo.roomW - this.$commonViewJs.getQx()
          )
          // console.log('k', k, 'l', l, l.x - k.x, l.y - k.y)
        }
        this.avlRect = this.$draw.toRect(
          k.x - this.offsetX,
          k.y,
          l.x - k.x,
          l.y - k.y
        )
      }
    },
    setArrCurveRect () {
      if (this.searchTabActive !== 'CurvedSurface') {
        return
      }
      var curveArea
      if (this.curveShape === '1' && this.curveCentralAngle) {
        // // 先清掉之前的左边的竖线
        // if (this.curveDirection === '1' && this.searchTabActive === 'CurvedSurface') {
        //   var clearLine = this.$draw.toLine(
        //     0,
        //     0,
        //     0,
        //     this.houseInfo.roomW,
        //     '#EAEAEA',
        //     2
        //   )
        //   this.arrRectLines.push(clearLine)
        // }

        // 画圆弧
        var curAng = this.curveDirection === '0' ? 180 : 0
        curveArea = this.$draw.toCurveArea(
          this.curveCenter - this.offsetX,
          this.houseInfo.roomW / 2,
          this.curveRadius,
          curAng,
          this.curveCentralAngle,
          this.coverScreenColor,
          this.$constant.canvasBgColor,
          2
        )
        this.arrCurveRect.push(curveArea)
      } else {
        let height = this.curveShape === '0' ? this.curveScreenHeight : this.curveChordLength
        let pointLX = 0 - this.offsetX
        let pointRX = this.curveDepth - this.offsetX
        let pointTY = (this.houseInfo.roomW - height) / 2
        let pointBY = (this.houseInfo.roomW + height) / 2
        this.arrRectLines.push(this.$draw.toLine(pointLX, pointTY, pointRX, pointTY, this.coverScreenColor, 2))
        this.arrRectLines.push(this.$draw.toLine(pointRX, pointTY, pointRX, pointBY, this.coverScreenColor, 2))
        this.arrRectLines.push(this.$draw.toLine(pointRX, pointBY, pointLX, pointBY, this.coverScreenColor, 2))
        this.arrRectLines.push(this.$draw.toLine(pointLX, pointBY, pointLX, pointTY, this.coverScreenColor, 2))
      }
      // else if (this.curveDirection === '0') {
      //   let rect0 = this.$draw.toRectArea(
      //     -this.curveDepth,
      //     0,
      //     this.curveDepth,
      //     this.houseInfo.roomW,
      //     this.$constant.roomLineColor,
      //     this.$constant.roomFillColor,
      //     2
      //   )
      //   this.arrRectArea.push(rect0)
      // }
    },
    setArrRectLines () {
      if (!this.drawData) {
        return
      }
      var rectLines
      const rectLineColor = this.$constant.rectLineColor
      const lineOpacity = 0.8
      if (this.isLShaped01) {
        const getAx = this.$commonViewJs.getAx()
        const getAz = this.$commonViewJs.getAz()
        for (let i = 0; i < this.drawData[0].length; i++) {
          rectLines = this.$draw.toLine(
            this.drawData[0][i].x,
            this.drawData[0][i].z,
            getAx,
            getAz,
            rectLineColor,
            lineOpacity
          )
          this.arrRectLines.push(rectLines)
        }
      } else {
        const endX = this.$commonViewJs.getAy() - this.offsetX
        const endY = this.houseInfo.roomW - this.graph.pjX
        for (let i = 0; i < this.drawData[0].length; i++) {
          rectLines = this.$draw.toLine(
            this.drawData[0][i].y - this.offsetX,
            this.houseInfo.roomW - this.drawData[0][i].x,
            endX,
            endY,
            rectLineColor,
            lineOpacity
          )
          this.arrRectLines.push(rectLines)
        }
      }
    },
    setArrCatchArea () {
      if (!this.drawData) {
        return
      }
      if (this.isLShaped01) {
        for (let i = 1; i < this.drawData.length; i++) {
          for (let j = 0; j < this.drawData[i].length; j++) {
            this.arrCatchArea.push(this.$draw.toPoint(this.drawData[i][j].x, this.drawData[i][j].z))
          }
        }
      } else {
        for (let i = 1; i < this.drawData.length; i++) {
          for (let j = 0; j < this.drawData[i].length; j++) {
            this.arrCatchArea.push(this.$draw.toPoint(this.drawData[i][j].y - this.offsetX, this.houseInfo.roomW - this.drawData[i][j].x))
          }
        }
      }
    },
    setArrLightingArea () {
      if (!this.drawData && !this.drawData[0]) {
        return
      }
      let data0 = this.drawData[1]
      let LightingPoints0 = []
      if (this.isLShaped01) {
        for (let i = 1; i < data0.length; i++) {
          LightingPoints0.push(this.$draw.toPoint(data0[i].x, data0[i].z))
        }
        if (data0.length === 0) {
          for (let i = 0; i < this.drawData[0].length; i++) {
            LightingPoints0.push(this.$draw.toPoint(this.drawData[0][i].x, this.drawData[0][i].z))
          }
        }
        LightingPoints0.push(this.$draw.toPoint(this.$commonViewJs.getAx(), this.$commonViewJs.getAz()))
      } else {
        for (let i = 1; i < data0.length; i++) {
          LightingPoints0.push(this.$draw.toPoint(data0[i].y - this.offsetX, this.houseInfo.roomW - data0[i].x))
        }
        if (data0.length === 0) {
          for (let i = 0; i < this.drawData[0].length; i++) {
            LightingPoints0.push(this.$draw.toPoint(this.drawData[0][i].y - this.offsetX, this.houseInfo.roomW - this.drawData[0][i].x))
          }
        }
        LightingPoints0.push(this.$draw.toPoint(this.$commonViewJs.getAy() - this.offsetX, this.houseInfo.roomW - this.graph.pjX))
      }
      this.arrLightingArea.push(LightingPoints0)
    },

    setArrDashLines () {
      if (this.isLShaped01) {
        // 投影仪中心的虚线
        let pointPX = this.$commonViewJs.getAx()
        this.arrDashLines.push(this.$draw.toLine(pointPX, 0, pointPX, this.heightInit))

        // wide端虚线
        let pointW = this.$commonViewJs.getLSWH()
        this.arrDashLines.push(this.$draw.toLine(0, pointW, this.widthInit, pointW))

        // Tele端虚线
        if (this.$commonViewJs.isAvlExist()) {
          let pointT = this.$commonViewJs.getLSTH()
          this.arrDashLines.push(this.$draw.toLine(0, pointT, this.widthInit, pointT))
        }

        // offset虚线
        if (this.$commonViewJs.isOffsetExist()) {
          let pointY = this.position === 1 ? this.heightInit - this.offset : this.offset
          this.arrDashLines.push(this.$draw.toLine(0, pointY, this.widthInit, pointY))
        }
      } else {
        var dashLine0 = this.$draw.toLine(
          0,
          this.houseInfo.roomW - this.graph.pjX,
          this.widthInit,
          this.houseInfo.roomW - this.graph.pjX
        )
        this.arrDashLines.push(dashLine0)
        var dashLine1 = this.$draw.toLine(
          this.$commonViewJs.getKy() - this.offsetX,
          0,
          this.$commonViewJs.getKy() - this.offsetX,
          this.houseInfo.roomW
        )
        this.arrDashLines.push(dashLine1)
        if (this.$commonViewJs.isAvlExist()) {
          var dashLine2 = this.$draw.toLine(
            this.$commonViewJs.getLy() - this.offsetX,
            0,
            this.$commonViewJs.getLy() - this.offsetX,
            this.houseInfo.roomW
          )
          this.arrDashLines.push(dashLine2)
        }
        if (this.$commonViewJs.isOffsetExist()) {
          var dashLine3 = this.$draw.toLine(
            this.offset,
            0,
            this.offset,
            this.houseInfo.roomW
          )
          this.arrDashLines.push(dashLine3)
        }
      }
    },
    setArrDashRemainLines () {
      var dashLine1
      if (this.dashFlag) {
        if (this.isLShaped01) {
          for (let i = 1; i < this.dashData.length; i++) {
            for (let j = 1; j < this.dashData[i].length; j++) {
              dashLine1 = this.$draw.toLine(this.dashData[i][j - 1].x, this.dashData[i][j - 1].z, this.dashData[i][j].x, this.dashData[i][j].z, '#000000', 2)
              this.arrDashRemainLines.push(dashLine1)
            }
            if (i === this.dashData.length - 1) {
              dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].x, this.dashData[i][this.dashData[i].length - 1].z, this.dashData[1][0].x, this.dashData[1][0].z, '#000000', 2)
              this.arrDashRemainLines.push(dashLine1)
            } else {
              dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].x, this.dashData[i][this.dashData[i].length - 1].z, this.dashData[i + 1][0].x, this.dashData[i + 1][0].z, '#000000', 2)
              this.arrDashRemainLines.push(dashLine1)
            }
          }
        } else {
          for (let i = 1; i < this.dashData.length; i++) {
            for (let j = 1; j < this.dashData[i].length; j++) {
              dashLine1 = this.$draw.toLine(this.dashData[i][j - 1].y, this.houseInfo.roomW - this.dashData[i][j - 1].x, this.dashData[i][j].y, this.houseInfo.roomW - this.dashData[i][j].x, '#000000', 2)
              this.arrDashRemainLines.push(dashLine1)
            }
            if (i === this.dashData.length - 1) {
              dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].y, this.houseInfo.roomW - this.dashData[i][this.dashData[i].length - 1].x, this.dashData[1][0].y, this.houseInfo.roomW - this.dashData[1][0].x, '#000000', 2)
              this.arrDashRemainLines.push(dashLine1)
            } else {
              dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].y, this.houseInfo.roomW - this.dashData[i][this.dashData[i].length - 1].x, this.dashData[i + 1][0].y, this.houseInfo.roomW - this.dashData[i + 1][0].x, '#000000', 2)
              this.arrDashRemainLines.push(dashLine1)
            }
          }
        }
      }
    },
    setArrOffsetLines () {
      if (this.$commonViewJs.isOffsetExist()) {
        var dashLine = this.$draw.toLine(
          this.offset,
          0,
          this.offset,
          this.houseInfo.roomW,
          this.$constant.dashLineColor,
          1.2
        )
        this.arrOffsetLines.push(dashLine)
      }
    },
    setArrHelpLine (proportion) {
      this.helpDisMin = 10 * proportion
      this.helpDisMax = 18 * proportion
      this.helpTextDis = 20 * proportion
      this.helpBesideDis = 10 * proportion
      this.arrHelpLines.splice(0, this.arrHelpLines.length)
      this.arrHelpText.splice(0, this.arrHelpText.length)

      if (this.isLShaped01) {
        this.setArrHelpLineLShaped(proportion)
        return
      }

      // 上辅助线
      var helpLine0 = this.$draw.toLine(
        0 - this.offsetX,
        0 - this.helpDisMin,
        0 - this.offsetX,
        0 - this.helpDisMax,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(helpLine0)
      if (this.searchTabActive !== 'CurvedSurface') {
        var helpLine1 = this.$draw.toLine(
          this.widthInit,
          0 - this.helpDisMin,
          this.widthInit,
          0 - this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine1)
        var helpLine2 = this.$draw.toLine(
          0,
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          this.widthInit,
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine2)
      }
      // let curDep = this.curveDirection === '0' ? -this.curveDepth : (this.curveDirection === '1' ? this.curveDepth : 0)
      // 添加上辅助线
      let curDep = this.curveDepth ? this.curveDepth : 0
      if (this.searchTabActive === 'CurvedSurface') {
        if (this.curveDepth > 0) {
          var helpLineLeftc = this.$draw.toLine(
            0 + curDep - this.offsetX,
            0 - this.helpDisMin,
            0 + curDep - this.offsetX,
            0 - this.helpDisMax,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLineLeftc)
          helpLineLeftc = this.$draw.toLine(
            0 + curDep - this.offsetX,
            0 - (this.helpDisMin + this.helpDisMax) / 2,
            0 - this.offsetX,
            0 - (this.helpDisMin + this.helpDisMax) / 2,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLineLeftc)
          var textName0 = this.$commonJs.changeUnitDraw(this.curveDepth, this.graph.unit, false)
          var helpText0 = this.$draw.toText(
            curDep / 2 - this.offsetX,
            0 - this.helpTextDis,
            textName0,
            'top'
          )
          this.arrHelpText.push(helpText0)
        }
        if (this.$commonViewJs.getAy() >= this.curveDepth) {
          let topHelpLine = this.$draw.toLine(
            0 + this.$commonViewJs.getAy() - this.offsetX,
            0 - this.helpDisMin,
            0 + this.$commonViewJs.getAy() - this.offsetX,
            0 - this.helpDisMax,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(topHelpLine)
          topHelpLine = this.$draw.toLine(
            0 + this.$commonViewJs.getAy() - this.offsetX,
            0 - (this.helpDisMin + this.helpDisMax) / 2,
            0 - this.offsetX,
            0 - (this.helpDisMin + this.helpDisMax) / 2,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(topHelpLine)
        }

        // 投写距離の合計値
        let pointX1 = 0 - this.offsetX
        let pointX2 = this.$commonViewJs.getAy() - this.offsetX
        let pointY1 = 0 - this.helpDisMin + this.helpDisMax / 2
        let pointY2 = 0 - this.helpDisMax / 2
        let pointY3 = 0 - (this.helpDisMin + this.helpDisMax) / 2 + this.helpDisMax / 2
        let color = this.$constant.helpColor
        let topLine
        // 开始竖线
        let topPoint = [{start: {x: pointX1, y: pointY1}, end: {x: pointX1, y: pointY2}}]
        // 横线
        topPoint.push({start: {x: pointX1, y: pointY3}, end: {x: pointX2, y: pointY3}})
        // 结束竖线
        topPoint.push({start: {x: pointX2, y: pointY1}, end: {x: pointX2, y: pointY2}})
        topPoint.forEach(item => {
          topLine = this.$draw.toLine(item.start.x, item.start.y, item.end.x, item.end.y, color, 0.8)
          this.arrHelpLines.push(topLine)
        })
      }
      // 右辅助线
      if (this.searchTabActive === 'CurvedSurface') {
        // スクリーン左端/右端から
        let heightV = this.curveShape === '1' ? this.curveChordLength : this.curveScreenHeight
        let pointX1 = this.widthInit + this.helpDisMin
        let pointX2 = this.widthInit + this.helpDisMax
        let pointX3 = this.widthInit + (this.helpDisMin + this.helpDisMax) / 2
        let pointY1 = (this.houseInfo.roomW - heightV) / 2
        let pointY2 = this.houseInfo.roomW - this.graph.pjX
        let pointY3 = (this.houseInfo.roomW + heightV) / 2
        // 投影仪中心 的 横线
        let rightPoint = [{start: {x: pointX1, y: pointY2}, end: {x: pointX2, y: pointY2}}]
        if (pointY1 > pointY2) {
          // 曲面弧上端 的 横线
          rightPoint.push({start: {x: pointX1, y: pointY1}, end: {x: pointX2, y: pointY1}})
          // 曲面弧上端 / 投影仪中心 的 竖线
          rightPoint.push({start: {x: pointX3, y: pointY1}, end: {x: pointX3, y: pointY2}})
        } else if (pointY1 < pointY2 && pointY2 < pointY3) {
          // 曲面弧上端 的 横线
          rightPoint.push({start: {x: pointX1, y: pointY1}, end: {x: pointX2, y: pointY1}})
          // 曲面弧下端 的 横线
          rightPoint.push({start: {x: pointX1, y: pointY3}, end: {x: pointX2, y: pointY3}})
          // 曲面弧上端 / 曲面弧下端 的 竖线
          rightPoint.push({start: {x: pointX3, y: pointY1}, end: {x: pointX3, y: pointY3}})
        } else {
          // 曲面弧下端 的 横线
          rightPoint.push({start: {x: pointX1, y: pointY3}, end: {x: pointX2, y: pointY3}})
          // 投影仪中心 / 曲面弧下端 的 竖线
          rightPoint.push({start: {x: pointX3, y: pointY2}, end: {x: pointX3, y: pointY3}})
        }
        let rightHelpLine
        rightPoint.forEach(item => {
          rightHelpLine = this.$draw.toLine(item.start.x, item.start.y, item.end.x, item.end.y, this.$constant.helpLineColor, 0.8)
          this.arrHelpLines.push(rightHelpLine)
        })
      } else {
        var helpLine3 = this.$draw.toLine(
          this.widthInit + this.helpDisMin,
          0,
          this.widthInit + this.helpDisMax,
          0,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine3)
        var helpLine4 = this.$draw.toLine(
          this.widthInit + this.helpDisMin,
          this.heightInit,
          this.widthInit + this.helpDisMax,
          this.heightInit,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine4)
        var helpLine5 = this.$draw.toLine(
          this.widthInit + (this.helpDisMin + this.helpDisMax) / 2,
          0,
          this.widthInit + (this.helpDisMin + this.helpDisMax) / 2,
          this.heightInit,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine5)
      }

      // 左辅助线
      var helpLineLeft
      if (this.searchTabActive === 'CurvedSurface') {
        // スクリーン幅
        let heightV = this.curveShape === '1' ? this.curveChordLength : this.curveScreenHeight
        let pointX1 = 0 - this.helpDisMin
        let pointX2 = 0 - this.helpDisMax
        let pointX3 = 0 - (this.helpDisMin + this.helpDisMax) / 2
        let pointY1 = (this.houseInfo.roomW - heightV) / 2
        let pointY2 = (this.houseInfo.roomW + heightV) / 2
        let leftPoint = [
          {start: {x: pointX1, y: pointY1}, end: {x: pointX2, y: pointY1}}, // スクリーン幅上端 的 横线
          {start: {x: pointX1, y: pointY2}, end: {x: pointX2, y: pointY2}}, // スクリーン幅下端 的 横线
          {start: {x: pointX3, y: pointY1}, end: {x: pointX3, y: pointY2}} // スクリーン幅上端 到  スクリーン幅下端 的 竖线
        ]
        leftPoint.forEach(item => {
          helpLineLeft = this.$draw.toLine(item.start.x, item.start.y, item.end.x, item.end.y, this.$constant.helpLineColor, 0.8)
          this.arrHelpLines.push(helpLineLeft)
        })
      } else {
        // curDep = this.curveDirection === '0' ? -this.curveDepth : 0
        helpLineLeft = this.$draw.toLine(
          0 - this.helpDisMin,
          0,
          0 - this.helpDisMax,
          0,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjX < this.houseInfo.roomW) this.arrHelpLines.push(helpLineLeft)
        this.mp = this.getPointCurMaxAndMin()
        if (!this.mp.minP || !this.mp.maxP) return
        helpLineLeft = this.$draw.toLine(
          0 - this.helpDisMin,
          this.houseInfo.roomW - this.mp.maxP.x,
          0 - this.helpDisMax,
          this.houseInfo.roomW - this.mp.maxP.x,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLineLeft)
        helpLineLeft = this.$draw.toLine(
          0 - this.helpDisMin,
          this.houseInfo.roomW - this.mp.minP.x,
          0 - this.helpDisMax,
          this.houseInfo.roomW - this.mp.minP.x,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLineLeft)
        helpLineLeft = this.$draw.toLine(
          0 - this.helpDisMin,
          this.houseInfo.roomW,
          0 - this.helpDisMax,
          this.houseInfo.roomW,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjX > 0) this.arrHelpLines.push(helpLineLeft)
        helpLineLeft = this.$draw.toLine(
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          0,
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          this.houseInfo.roomW,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLineLeft)
        helpLineLeft = this.$draw.toLine(
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          this.houseInfo.roomW - this.mp.maxP.x,
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          0,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjX > this.houseInfo.roomW) this.arrHelpLines.push(helpLineLeft)
        helpLineLeft = this.$draw.toLine(
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          this.houseInfo.roomW - this.mp.minP.x,
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          this.houseInfo.roomW,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjX < 0) this.arrHelpLines.push(helpLineLeft)
      }
      // 下辅助线
      var bottomLine
      let bottomPoint = []
      if (this.searchTabActive === 'CurvedSurface') {
        // 可移动区域
        if (this.$commonViewJs.isAvlExist()) {
          let pointX1 = this.$commonViewJs.getKy() - this.offsetX
          let pointX2 = this.$commonViewJs.getLy() - this.offsetX
          let pointY1 = this.houseInfo.roomW + this.helpDisMin
          let pointY2 = this.houseInfo.roomW + this.helpDisMax
          let pointY3 = this.houseInfo.roomW + (this.helpDisMin + this.helpDisMax) / 2
          pointX1 = this.$commonViewJs.getKy() - this.offsetX
          bottomPoint.push({start: {x: pointX1, y: pointY1}, end: {x: pointX1, y: pointY2}})
          bottomPoint.push({start: {x: pointX2, y: pointY1}, end: {x: pointX2, y: pointY2}})
          bottomPoint.push({start: {x: pointX1, y: pointY3}, end: {x: pointX2, y: pointY3}})
        }
        bottomPoint.forEach(item => {
          bottomLine = this.$draw.toLine(item.start.x, item.start.y, item.end.x, item.end.y, this.$constant.helpLineColor, 0.8)
          this.arrHelpLines.push(bottomLine)
        })
      }
      this.setArrHelpText(proportion)
    },
    setArrHelpLineLShaped (proportion) {
      // 下边的辅助线(桌面), 上边的辅助线(吊顶)
      let pointX1 = 0
      let pointX2 = this.widthInit
      let pointY1 = this.position === 1 ? 0 - this.helpDisMin : this.heightInit + this.helpDisMin
      let pointY2 = this.position === 1 ? 0 - this.helpDisMax : this.heightInit + this.helpDisMax
      let pointY3 = this.position === 1 ? 0 - (this.helpDisMin + this.helpDisMax) / 2 : this.heightInit + (this.helpDisMin + this.helpDisMax) / 2
      let bottomPoint = [
        {x1: pointX1, y1: pointY1, x2: pointX1, y2: pointY2},
        {x1: pointX2, y1: pointY1, x2: pointX2, y2: pointY2},
        {x1: pointX1, y1: pointY3, x2: pointX2, y2: pointY3}
      ]
      let bottomHelpLine
      bottomPoint.forEach(item => {
        bottomHelpLine = this.$draw.toLine(item.x1, item.y1, item.x2, item.y2, this.$constant.helpLineColor, 0.8)
        this.arrHelpLines.push(bottomHelpLine)
      })

      // 右边的辅助线(桌面), 左边的辅助线(吊顶)
      pointX1 = this.position === 1 ? 0 - this.helpDisMin : this.widthInit + this.helpDisMin
      pointX2 = this.position === 1 ? 0 - this.helpDisMax : this.widthInit + this.helpDisMax
      let pointX3 = this.position === 1 ? 0 - (this.helpDisMin + this.helpDisMax) / 2 : this.widthInit + (this.helpDisMin + this.helpDisMax) / 2
      pointY1 = 0
      pointY2 = this.heightInit
      let rightPoint = [
        {x1: pointX1, y1: pointY1, x2: pointX2, y2: pointY1},
        {x1: pointX1, y1: pointY2, x2: pointX2, y2: pointY2},
        {x1: pointX3, y1: pointY1, x2: pointX3, y2: pointY2}
      ]
      let rightHelpLine
      rightPoint.forEach(item => {
        rightHelpLine = this.$draw.toLine(item.x1, item.y1, item.x2, item.y2, this.$constant.helpLineColor, 0.8)
        this.arrHelpLines.push(rightHelpLine)
      })

      // 上边的辅助线(桌面), 下边的辅助线(吊顶)
      this.mp = this.getPointCurMaxAndMin()
      if (!this.mp.minP || !this.mp.maxP) return
      pointX1 = 0
      pointX2 = this.mp.minP.x
      pointX3 = this.mp.maxP.x
      let pointX4 = this.widthInit
      pointY1 = this.position === 1 ? this.heightInit + this.helpDisMin : 0 - this.helpDisMin
      pointY2 = this.position === 1 ? this.heightInit + this.helpDisMax : 0 - this.helpDisMax
      pointY3 = this.position === 1 ? this.heightInit + (this.helpDisMin + this.helpDisMax) / 2 : 0 - (this.helpDisMin + this.helpDisMax) / 2
      let topPoint = []
      // 上边的竖线
      if (this.graph.pjX > 0) {
        topPoint.push({x1: pointX1, y1: pointY1, x2: pointX1, y2: pointY2})
      }
      topPoint.push({x1: pointX2, y1: pointY1, x2: pointX2, y2: pointY2})
      topPoint.push({x1: pointX3, y1: pointY1, x2: pointX3, y2: pointY2})
      if (this.graph.pjX < this.widthInit) {
        topPoint.push({x1: pointX4, y1: pointY1, x2: pointX4, y2: pointY2})
      }
      // 上边的横线
      topPoint.push({x1: pointX1, y1: pointY3, x2: pointX4, y2: pointY3})
      if (this.graph.pjX < 0) {
        topPoint.push({x1: pointX2, y1: pointY3, x2: pointX1, y2: pointY3})
      }
      if (this.graph.pjX > this.widthInit) {
        topPoint.push({x1: pointX3, y1: pointY3, x2: pointX4, y2: pointY3})
      }
      // console.log('pointX2', pointX2, 'pointX3', pointX3)
      let topHelpLine
      topPoint.forEach(item => {
        topHelpLine = this.$draw.toLine(item.x1, item.y1, item.x2, item.y2, this.$constant.helpLineColor, 0.8)
        this.arrHelpLines.push(topHelpLine)
      })

      this.setArrHelpTextLShaped(proportion)
    },
    // 获取x轴坐标在主墙上的最大值最小值，因为数据存在误差，判断当数据x最大时，取最大值的x为this.houseInfo.roomW的点(为曲面)
    getPointCurMaxAndMin () {
      let initDMax, initDMin
      for (let i = 1; i < this.drawData.length; i++) {
        if (this.drawData[i].length > 0) {
          initDMax = this.drawData[i][0]
          initDMin = this.drawData[i][0]
          break
        }
      }

      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          if (this.drawData[i][j].x > initDMax.x) {
            initDMax = this.drawData[i][j]
          }
          if (this.drawData[i][j].x < initDMin.x) {
            initDMin = this.drawData[i][j]
          }
        }
      }
      return {
        maxP: initDMax,
        minP: initDMin
      }
    },
    // 获取x轴坐标在主墙上的最大值最小值，因为数据存在误差，判断当数据x最大时，取最大值的x为this.houseInfo.roomW的点
    getPointMaxAndMin () {
      let maxFlag = false
      let minFlag = false
      let outFlag = true
      let initDMax = this.drawData[1][0]
      let initDMin = this.drawData[1][0]
      for (let i = 0; i < this.drawData[0].length; i++) {
        if (this.drawData[0][i].y - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0) < this.limitData) {
          outFlag = false
        }
      }
      if (outFlag) {
        return {
          maxP: {x: this.houseInfo.roomW, y: 0, z: 0},
          minP: {x: 0, y: 0, z: 0}
        }
      }
      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          if (Math.abs(this.drawData[i][j].x - this.houseInfo.roomW) < this.limitData && !maxFlag) {
            initDMax = this.drawData[i][j]
            maxFlag = true
          } else if (this.drawData[i][j].x < this.limitData && !minFlag) {
            initDMin = this.drawData[i][j]
            minFlag = true
          } else if (this.drawData[i][j].y - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0) < this.limitData) {
            if (this.drawData[i][j].x > initDMax.x && !maxFlag) {
              initDMax = this.drawData[i][j]
            }
            if (this.drawData[i][j].x < initDMin.x && !minFlag) {
              initDMin = this.drawData[i][j]
            }
          }
        }
      }
      return {
        maxP: initDMax,
        minP: initDMin
      }
    },
    setArrHelpText (proportion) {
      let lis = 7 * proportion

      let curDis = this.curveDepth && this.searchTabActive === 'CurvedSurface' ? this.curveDepth : 0
      var textName0 = this.$commonJs.changeUnitDraw(this.houseInfo.roomD, this.graph.unit, false)
      var helpText0
      // 上辅文本
      if (this.searchTabActive === 'CurvedSurface') {
        let textName = this.$commonJs.changeUnitDraw(this.graph.pjY - (this.curveDirection === '0' ? curDis : 0), this.graph.unit, false)
        helpText0 = this.$draw.toText(
          curDis + (this.graph.pjY / 2) - this.offsetX,
          0 - this.helpTextDis,
          textName,
          'top'
        )
        this.arrHelpText.push(helpText0)

        // 投写距離の合計値
        let topText, topHelpText
        let pointX1 = this.$commonViewJs.getAy()
        let pointY1 = 0 - this.helpTextDis
        let color = this.$constant.helpColor
        let topTextInfo = [{text: pointX1, x: pointX1 / 2 - this.offsetX, y: pointY1}]
        topTextInfo.forEach(item => {
          topText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
          topHelpText = this.$draw.toText(item.x, item.y, topText, 'top', color)
          this.arrHelpText.push(topHelpText)
        })
      } else {
        let curDisName = this.$commonJs.changeUnitDraw(this.houseInfo.roomD - curDis, this.graph.unit, false)
        helpText0 = this.$draw.toText(
          (this.widthInit + curDis) / 2,
          0 - this.helpTextDis,
          curDisName,
          'top'
        )
        this.arrHelpText.push(helpText0)
      }
      // 单位
      textName0 = '(' + this.unitLabel + ')'
      helpText0 = this.$draw.toText(
        this.widthInit,
        0 - this.helpTextDis,
        textName0,
        'unit'
      )
      this.arrHelpText.push(helpText0)
      // 右辅文本
      let rightText, rightHelpText, rightTextInfo
      if (this.searchTabActive === 'CurvedSurface') {
        let heightV = this.curveShape === '1' ? this.curveChordLength : this.curveScreenHeight
        let pointX1 = this.widthInit + this.helpTextDis + this.helpBesideDis
        let pointY1 = (this.houseInfo.roomW - heightV) / 2
        let pointY2 = this.houseInfo.roomW - this.graph.pjX
        let pointY3 = (this.houseInfo.roomW + heightV) / 2
        if (pointY1 > pointY2) {
          rightTextInfo = [{text: pointY1 - pointY2, x: pointX1, y: pointY1 - (pointY1 - pointY2) / 2 + lis}]
        } else if (pointY1 < pointY2 && pointY2 < pointY3) {
          rightTextInfo = [
            {text: pointY2 - pointY1, x: pointX1, y: pointY1 + (pointY2 - pointY1) / 2 + lis},
            {text: pointY3 - pointY2, x: pointX1, y: pointY2 + (pointY3 - pointY2) / 2 + lis}
          ]
        } else {
          rightTextInfo = [{text: pointY2 - pointY3, x: pointX1, y: pointY3 + (pointY2 - pointY3) / 2 + lis}]
        }
        rightTextInfo.forEach(item => {
          rightText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
          rightHelpText = this.$draw.toText(item.x, item.y, rightText, 'right')
          this.arrHelpText.push(rightHelpText)
        })
      } else {
        var textName1 = this.$commonJs.changeUnitDraw(this.houseInfo.roomW, this.graph.unit, false)
        var helpText1 = this.$draw.toText(
          this.widthInit + this.helpTextDis + this.helpBesideDis,
          this.heightInit / 2,
          textName1,
          'right'
        )
        this.arrHelpText.push(helpText1)
      }

      // 左辅文本
      var textNameLeft, helpTextLeft
      // 左边标注的尺寸被覆盖，所以需要调整
      let leftMov = this.graph.unit === 'T_FEET_FRACTION' ? 40 : 10
      if (this.searchTabActive === 'CurvedSurface') {
        let heightV = this.curveShape === '1' ? this.curveChordLength : this.curveScreenHeight
        textNameLeft = this.$commonJs.changeUnitDraw(heightV, this.graph.unit, false)
        helpTextLeft = this.$draw.toText(
          0 - this.helpTextDis - this.helpBesideDis + leftMov,
          this.houseInfo.roomW / 2 + lis,
          textNameLeft,
          'left'
        )
        this.arrHelpText.push(helpTextLeft)
      } else {
        // let curDep = this.curveDirection === '0' ? -this.curveDepth : 0
        textNameLeft = this.$commonJs.changeUnitDraw(
          this.houseInfo.roomW - this.mp.maxP.x, this.graph.unit, false
        )
        helpTextLeft = this.$draw.toText(
          0 - this.helpTextDis - this.helpBesideDis + leftMov,
          (this.houseInfo.roomW - this.mp.maxP.x) / 2 + lis,
          textNameLeft,
          'left'
        )
        this.arrHelpText.push(helpTextLeft)
        textNameLeft = this.$commonJs.changeUnitDraw(
          this.mp.maxP.x - this.mp.minP.x, this.graph.unit, false
        )
        helpTextLeft = this.$draw.toText(
          0 - this.helpTextDis - this.helpBesideDis + 10,
          (this.houseInfo.roomW * 2 - this.mp.maxP.x - this.mp.minP.x) / 2 + lis,
          textNameLeft,
          'left'
        )
        this.arrHelpText.push(helpTextLeft)
        textNameLeft = this.$commonJs.changeUnitDraw(
          this.mp.minP.x, this.graph.unit, false
        )
        helpTextLeft = this.$draw.toText(
          0 - this.helpTextDis - this.helpBesideDis + leftMov,
          (this.houseInfo.roomW * 2 - this.mp.minP.x) / 2 + lis,
          textNameLeft,
          'left'
        )
        this.arrHelpText.push(helpTextLeft)
      }
      // 下辅助线的文字
      let bottomText, bottomHelpText
      let bottomTextInfo = []
      if (this.searchTabActive === 'CurvedSurface') {
        if (this.$commonViewJs.isAvlExist()) {
          let pointX1 = (this.$commonViewJs.getLy() + this.$commonViewJs.getKy()) / 2 - this.offsetX
          let pointY1 = this.houseInfo.roomW + this.helpTextDis + this.helpBesideDis
          bottomText = this.$commonViewJs.getLy() - this.$commonViewJs.getKy()
          bottomTextInfo.push({text: bottomText, x: pointX1, y: pointY1})
        }
        bottomTextInfo.forEach(item => {
          bottomText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
          bottomHelpText = this.$draw.toText(item.x, item.y, bottomText, 'bottom')
          this.arrHelpText.push(bottomHelpText)
        })
      }
    },

    setArrHelpTextLShaped (proportion) {
      let lis = 7 * proportion
      let cvPos

      // 右辅助文字(桌面), 左边的辅助文字(吊顶)
      // 左边标注的尺寸被覆盖，所以需要调整
      let leftMov = this.graph.unit === 'T_FEET_FRACTION' ? 40 : 10
      let rightText = this.$commonJs.changeUnitDraw(this.heightInit, this.graph.unit, false)
      cvPos = this.position === 1 ? 'left' : 'right'
      let pointX1 = this.position === 1 ? 0 - this.helpTextDis - this.helpBesideDis + leftMov : this.widthInit + this.helpTextDis + this.helpBesideDis
      let pointY1 = this.heightInit / 2 + lis
      this.arrHelpText.push(this.$draw.toText(pointX1, pointY1, rightText, cvPos))

      // 下边的辅助文字(桌面), 上边的辅助文字(吊顶)
      let bottomText
      cvPos = this.position === 1 ? 'top' : 'bottom'
      bottomText = this.$commonJs.changeUnitDraw(this.widthInit, this.graph.unit, false)
      pointX1 = this.widthInit / 2
      pointY1 = this.position === 1 ? 0 - this.helpTextDis : this.heightInit + this.helpTextDis + this.helpBesideDis
      this.arrHelpText.push(this.$draw.toText(pointX1, pointY1, bottomText, cvPos))

      // 单位
      pointX1 = this.position === 1 ? this.widthInit : this.widthInit + this.helpTextDis + this.helpBesideDis
      pointY1 = 0 - this.helpTextDis
      this.arrHelpText.push(this.$draw.toText(pointX1, pointY1, '(' + this.unitLabel + ')', 'unit'))

      // 上边的辅助文字(桌面), 下边的辅助文字(吊顶)
      if (!this.mp.minP || !this.mp.maxP) return
      let topText, topHelpText, topTextInfo, pointX2, pointX3
      cvPos = this.position === 0 ? 'top' : 'bottom'
      pointX1 = this.mp.minP.x / 2
      pointX2 = (this.mp.maxP.x + this.mp.minP.x) / 2
      pointX3 = (this.widthInit + this.mp.maxP.x) / 2
      pointY1 = this.position === 0 ? 0 - this.helpTextDis : this.heightInit + this.helpTextDis + this.helpBesideDis
      topTextInfo = [
        {text: this.mp.minP.x, x: pointX1, y: pointY1},
        {text: this.mp.maxP.x - this.mp.minP.x, x: pointX2, y: pointY1},
        {text: this.widthInit - this.mp.maxP.x, x: pointX3, y: pointY1}
      ]
      topTextInfo.forEach(item => {
        topText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
        topHelpText = this.$draw.toText(item.x, item.y, topText, cvPos)
        this.arrHelpText.push(topHelpText)
      })
    },

    onResize () {
      // TODO set conponent size
      this.sliderHeight = this.child.$refs.canvas_side.offsetHeight * 0.35 + 'px'
      this.child.resizeDraw()
    },

    testDigitalNegative (e, key) {
      e = e || '0'
      e = e.replace(/[^(\-|+)0-9|.]/ig, '')
      let tempArray = e.split('.')
      this.hAngleDataSlider = e || 0
      if (e && e !== '-' && ((tempArray.length > 1 && tempArray[1]) || tempArray.length === 1)) {
        this.hAngleDataSlider = (e * 1).toFixed(1) * 1
        this[key] = (e * 1).toFixed(1) * 1
      }
    },

    testDigitalNegativeBlur () {
      if (isNaN(this.hAngleDataSlider)) {
        let e = '0'
        this.hAngleDataSlider = (e * 1).toFixed(1) * 1
        this.hAngleData = (e * 1).toFixed(1) * 1
      }
    },

    toCenter () {
      if (!this.throw_distance_checked) {
        this.PJX(this.houseInfo.roomW / 2)
      }
    },

    moveCenter (value) {
      let temp = 18
      this.centerPosition.x = value.x
      this.centerPosition.y = value.y + this.$refs.topView.$el.offsetTop + temp
    }
  },

  watch: {
    hAngleData (newValue) {
      this.hAngleDataSlider = newValue
    },
    coverScreenColor () {
      this.setArrCurveRect()
    },
    isLShaped01 (newValue, oldValue) {
      this.widthInit = newValue ? this.houseInfo.roomW : this.houseInfo.roomD
      this.heightInit = newValue ? this.houseInfo.roomH : this.houseInfo.roomW
      this.$nextTick(function () {
        this.child.onHouseInfoChanged()
      })
    }
  }
}
</script>

<style scoped>
.top-view {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  border-right: 1px solid #bdbdbd;
  background: #fff;
}

.top-img {
  background: url('../../assets/parts/icon/icon_top.png') no-repeat center;
  width: 30px;
  height: 30px;
  float: left;
}

.top-view >>> .canvas_side {
  text-align: center;
  width: calc(100% - 55px);
  height: calc(100% - 60px);
  position: absolute;
  bottom: 0;
  left: 0;
}

.middle-btn {
  position: absolute;
  text-align: center;
  font-size: 12px;
  line-height: 23px;
  height: 23px;
  background: rgb(0, 50, 152);
  color: rgb(255, 255, 255);
  border-radius: 4px;
  cursor: pointer;
  transform: translate(-50%, -15px);
  transform:rotate(0deg);
  padding: 0 10px;
}

.middle-btndis{
  background: var(--btn-disable-color);
  position: absolute;
  text-align: center;
  font-size: 12px;
  line-height: 23px;
  height: 23px;
  color: rgb(180, 180, 180);
  border-radius: 4px;
  cursor: pointer;
  transform: translate(-50%, -15px);
  transform:rotate(0deg);
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/graph/topView.vue